import Icon from '../Icon';
import { Container, ModalBody } from './Modals.styles';

const Modal = ({ children, onClose }) => (
    <Container>
        <ModalBody>
            <Icon icon="pcom-icon-close" size={18} onClick={() => onClose()} className="pcom-icon-close" />
            {children}
        </ModalBody>
    </Container>
);

export default Modal;
